import { Form, message } from 'antd'
import { useCallback, useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { appRoutes } from '../../../../containers/Router/routes'
import { LocalizationContext } from '../../../../providers/LocalizationProvider'
import { useDeleteMutation, useGetQuery, usePatchMutation } from '../../../../query'

const useLocationMap = () => {
  const { t, dictionary } = useContext(LocalizationContext)
  const locationsPage = dictionary.locationsPage

  const { id } = useParams<{ id: string }>()

  const [form] = Form.useForm()

  const history = useHistory()

  const { data: location, status } = useGetQuery('locations', id)

  const [patchLocation, { status: patchStatus }] = usePatchMutation('locations')

  const [deleteLocation, { status: deleteStatus }] = useDeleteMutation('locations')

  const onFinish = useCallback(
    async (values) => {
      if (!id) {
        throw new Error(t(locationsPage.incorrectId))
      }

      try {
        await patchLocation({
          id,
          data: values
        })

        message.success(t(locationsPage.updated))
      } catch (e) {
        console.log(e)
      }
    },
    [id]
  )

  const onDelete = useCallback(async () => {
    if (!id) {
      throw new Error(t(locationsPage.incorrectId))
    }

    try {
      await deleteLocation(id)

      history.push(appRoutes.locations.path)
    } catch (e) {
      console.log(e)
    }
  }, [id])

  return {
    location,
    form,
    onFinish,
    patchLoading: patchStatus === 'loading',
    onDelete,
    deleteLoading: deleteStatus === 'loading'
  }
}
export default useLocationMap
